import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../../atoms/Icon';
import ImagePreloader from '../../../utils/ImagePreloader';
import ColorFinder from '../../../utils/ColorFinder';


/**
 * A simple OptionsSelector.
 */

const shyLabel = label => {
	return label.split('/').join(' / ');
};

class OptionsSelector extends React.Component {
	constructor(props) {
      super(props);
      this.mouseOver = this.mouseOver.bind(this);
      this.mouseOut = this.mouseOut.bind(this);
      this.insuranceInfo = this.insuranceInfo.bind(this);
      this.state = {
        info: false
      };
    }
	componentDidMount() {
		if(this.props.isSingleChoice) {
			this.props.onClick(this.props.choice, this.props.id);
		}
	}
	mouseOver() {
		this.setState({info:true});
	}
	mouseOut() {
		this.setState({info:false});
	}
	insuranceInfo() {
		this.props.showInfo(this.props.typeOfInsurance, this.props.isGostudent);
	}
	getPreview() {
		if(this.props.type==='image') {
			return <ImagePreloader alt={this.props.choice.preview} src={this.props.choice.preview} useAsBg={true} />;
		}
		let color = ColorFinder.get(this.props.choice.preview);
		if(color.valid) {
			return <div className="color" style={{backgroundColor:color.rgb}}></div>;
		}
		return <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNgYAAAAAMAASsJTYQAAAAASUVORK5CYII=" alt="blank" />
	}
    render () {
        return (
          <div className={`optionsselector${this.props.selected?" selected":""}`}>
          	<div onClick={() => this.props.onClick(this.props.choice, this.props.id)}>
            	<Icon filename="selected" />
            
	            <div className="inner">
	            	<div className={`preview ${this.props.type}`}>
	              		{this.getPreview()}
	              	</div>
	              	<div className="label">
	              		{shyLabel(this.props.choice.label)}
	              	</div>
	            </div>
            </div>
            {this.props.isInsurance &&
        	<div>
        		<Icon filename="information" onMouseOver={() => this.mouseOver()} onMouseOut={() => this.mouseOut()} onClick={this.insuranceInfo}/>
        		<div className={`insurancehint${this.state.info?" active":""}`}>Klicken für {`${this.props.typeOfInsurance==="wg"?"SchoolProtect":"Versicherungs"}`}&shy;bedingungen</div>
        	</div>}
			{this.props.isGostudent &&
        	<div>
        		<Icon filename="information" onMouseOver={() => this.mouseOver()} onMouseOut={() => this.mouseOut()} onClick={this.insuranceInfo}/>
        		<div className={`insurancehint${this.state.info?" active":""}`}>Klicken für Gostudent Bedingungen</div>
        	</div>}
          </div>
        );
    }

}

OptionsSelector.propTypes = {
	/** preview type */
	type: PropTypes.string,
	/** Button label */
	choice: PropTypes.object.isRequired,
	/** Gets called when the user clicks on the item */
	onClick: PropTypes.func,
	/** boolean */
	selected: PropTypes.bool,
	/** boolean */
	isInsurance: PropTypes.bool,
	/** string */
	typeOfInsurance: PropTypes.string
}

OptionsSelector.defaultProps = {
	/* eslint-disable no-console */
	onClick: event => {
		console.log('You have clicked a OptionsSelector Component!', event.target);
	},
	/* eslint-enable no-console */
	type: '',
	typeOfInsurance: 'std',
	selected: false,
	isInsurance: true
	
}


export default OptionsSelector;





// WEBPACK FOOTER //
// ./src/components/molecules/OptionsSelector/OptionsSelector.js